import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
import { notices, noticesImage } from '../data/homepage';

/** Same blob as the hero, mirrored, for the photo beside the notices. */
const BLOB = '46% 54% 58% 42% / 56% 44% 56% 44%';
/** Town icon, stamped over each notice image the way the Town does. */
const ICON_SRC = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/06/Bonnyville_Icon_Gold_RGB.png';
export function News() {
  return <section aria-labelledby="local-notices-title" className="bg-ville-lime" data-id="element-1677" data-mp="d212j5rervhp">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-1678" data-mp="hz0wiiazh7sg">
        <div className="grid items-center gap-10 lg:grid-cols-[minmax(0,32%)_minmax(0,1fr)] lg:gap-14" data-id="element-1679" data-mp="3bpkygesxnsc">
          <div className="relative mx-auto w-full max-w-[420px]" data-id="element-1680" data-mp="8a96wgteazkp">
            <span aria-hidden="true" className="absolute -inset-4 border-2 border-ville-navy" style={{
            borderRadius: BLOB
          }} data-id="element-1681" data-mp="88fzv0evedc6" />
            <img src={noticesImage} alt="" className="relative block aspect-square w-full object-cover" style={{
            borderRadius: BLOB
          }} data-id="element-1682" data-mp="10r3fi0b3l05v" />
          </div>

          <div className="py-4 lg:py-14" data-id="element-1683" data-mp="2ssxsjo5ib61k">
            <p className="text-center font-display text-lg font-extrabold text-ville-navy" data-id="element-1684" data-mp="2su0gpobg2uds">Stay Connected</p>
            <h2 id="local-notices-title" className="mt-1 text-center font-display text-4xl font-extrabold tracking-tight text-ville-navy sm:text-5xl" data-id="element-1685" data-mp="37j519c5ppap2">
              Local Notices
            </h2>

            <ul className="mt-8 grid gap-5 sm:grid-cols-3" data-id="element-1686" data-mp="3ggp6ew6p3r4y">
              {notices.map(notice => <li key={notice.id} className="flex" data-id="element-1687" data-mp="3bidvei4nzal5">
                  <article className="flex w-full flex-col overflow-hidden rounded-2xl border-2 border-ville-navy bg-ville-sand" data-id="element-1688" data-mp="3qgfykr7s9u1v">
                    <div className="relative h-[150px] shrink-0" data-id="element-1689" data-mp="3lh3c47ktqozt">
                      <img src={notice.image} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-1690" data-mp="1w2f5kmyx019p" />
                      <span className="absolute inset-0 bg-ville-blue/70" aria-hidden="true" data-id="element-1691" data-mp="1r3lrasbt068h" />
                      <div className="absolute inset-x-0 top-0 flex items-center gap-2 px-3 pt-3" data-id="element-1692" data-mp="2grr59leanek5">
                        <img src={ICON_SRC} alt="" aria-hidden="true" className="h-6 w-auto shrink-0" data-id="element-1693" data-mp="2kst4414atoll" />
                        <span className="min-w-0 leading-none" data-id="element-1694" data-mp="2prmkc1ayztpg">
                          <span className="block truncate font-display text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-1695" data-mp="2pu8rw0xv297o">
                            Town of Bonnyville
                          </span>
                          <span className="mt-0.5 block text-[8px] font-bold uppercase tracking-[0.14em] text-ville-lime" data-id="element-1696" data-mp="33rxd59vubid9">
                            North of Expected
                          </span>
                        </span>
                      </div>
                      <p className="absolute inset-x-0 bottom-9 text-center text-sm font-bold text-white" data-id="element-1697" data-mp="3dh8j4nnfk6wx">
                        {notice.caption}
                      </p>
                      <span className="absolute inset-x-0 bottom-0 flex justify-center" data-id="element-1698" data-mp="3nf4u9fgdb1v1">
                        <span className="w-4/5 bg-ville-lime py-1 text-center text-xs font-extrabold text-ville-navy" data-id="element-1699" data-mp="1bt41q9dem5i3">
                          {notice.tag}
                        </span>
                      </span>
                    </div>

                    <div className="flex flex-1 flex-col bg-white px-4 py-4" data-id="element-1700" data-mp="11un5oxzlz0p6">
                      <p className="text-[11px] font-bold uppercase tracking-wider text-slate-500" data-id="element-1701" data-mp="wwlluaucyxcn">{notice.date}</p>
                      <h3 className="mt-2 font-display text-[17px] font-extrabold leading-snug text-ville-navy" data-id="element-1702" data-mp="1uiivdiqrfscg">
                        {notice.title}
                      </h3>
                      <a href="#accueil" className="mt-auto pt-4 text-xs font-extrabold uppercase tracking-wider text-ville-blue underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1703" data-mp="1ks7l7eghgmx4">
                        Read more
                      </a>
                    </div>
                  </article>
                </li>)}
            </ul>

            <p className="mt-8 text-center" data-id="element-1704" data-mp="1szipn0wc9tbg">
              <a href="#accueil" className="inline-flex items-center gap-1.5 rounded-full bg-ville-spring px-5 py-2 text-sm font-bold text-ville-navy transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-navy focus-visible:ring-offset-2 focus-visible:ring-offset-ville-lime" data-id="element-1705" data-mp="1y0g7fcdfslcf">
                <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-1706" data-mp="2btej69a6sq25" />
                Older Entries
              </a>
            </p>
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="-mb-px mt-6 w-full" data-id="element-1707" data-mp="220qk17vqia09">
        <svg viewBox="0 0 1440 140" preserveAspectRatio="none" className="block h-[64px] w-full sm:h-[110px]" data-id="element-1708" data-mp="270381vycdn4f">
          <path d="M0,92 C240,36 450,138 720,100 C990,62 1220,16 1440,68 L1440,140 L0,140 Z" fill="#063731" data-id="element-1709" data-mp="2upxik6v6uzli" />
        </svg>
      </div>
    </section>;
}